import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Award, ExternalLink, X, Medal } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const certifications = [
  {
    id: 1,
    name: 'Manual Testing and Defect Management',
    organization: 'Microsoft',
    imageUrl: 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~2NUSSGERNX79/CERTIFICATE_LANDING_PAGE~2NUSSGERNX79.jpeg',
    pdfUrl: 'https://coursera.org/share/ad6b25407485639af46d578a4eb61f59',
    description: 'Issued on Sep 2026',
  },
  {
    id: 2,
    name: 'Software Testing Fundamentals and Methodologies',
    organization: 'Microsoft',
    imageUrl: 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~NJA84KEZEE9S/CERTIFICATE_LANDING_PAGE~NJA84KEZEE9S.jpeg',
    pdfUrl: 'https://coursera.org/share/2cfd6b8e3ad2caae03358efdb29c7a8a',
    description: 'Issued on Aug 2026',
  },
  {
    id: 3,
    name: 'Introduction to Selenium',
    organization: 'Coursera',
    imageUrl: 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~2U4TXBLTQC0T/CERTIFICATE_LANDING_PAGE~2U4TXBLTQC0T.jpeg',
    pdfUrl: 'https://coursera.org/share/53523d11b7513b4623e2fff7f7b54f8a',
    description: 'Issued on Apr 2026',
  },
  {
    id: 4,
    name: 'Playwright: Web Automation Testing From Zero to Hero',
    organization: 'Udemy',
    imageUrl: 'https://udemy-certificate.s3.amazonaws.com/image/UC-19c138ec-f5b5-4b9f-97fb-aab360a11fbf.jpg',
    pdfUrl: 'https://udemy-certificate.s3.amazonaws.com/pdf/UC-19c138ec-f5b5-4b9f-97fb-aab360a11fbf.pdf',
    description: 'Issued on Apr 2025',
  },
  {
    id: 5,
    name: 'Karate DSL: API Automation and Performance from Zero to Hero',
    organization: 'Udemy',
    imageUrl: 'https://udemy-certificate.s3.amazonaws.com/image/UC-40458c08-b9f8-41c9-be01-481ceee0f5e9.jpg',
    pdfUrl: 'https://udemy-certificate.s3.amazonaws.com/pdf/UC-40458c08-b9f8-41c9-be01-481ceee0f5e9.pdf',
    description: 'Issued on Oct 2024',
  },
  {
    id: 6,
    name: 'Postman: The Complete Guide REST API Testing',
    organization: 'Udemy',
    imageUrl: 'https://udemy-certificate.s3.amazonaws.com/image/UC-273924c9-0a25-4816-b80b-d4b19b804f3a.jpg',
    pdfUrl: 'https://udemy-certificate.s3.amazonaws.com/pdf/UC-273924c9-0a25-4816-b80b-d4b19b804f3a.pdf',
    description: 'Issued Apr on 2024',
  },
  {
    id: 7,
    name: 'Binar Academy Bootcamp - Quality Assurance',
    organization: 'Binar Academy',
    imageUrl: 'https://i.imgur.com/EVEzUWb.jpeg',
    pdfUrl: 'https://drive.google.com/file/d/1Eh8u_pUQ9hKQlByfWUfOJ_4M80SLkJb5/view',
    description: 'Issued Dec on 2022',
  },
];

const badges = [
  {
    id: 1,
    name: 'API Test Automation',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/q22cc5OWT0WyA8IJ440m1w/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/q22cc5OWT0WyA8IJ440m1w?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on June 2024',
  },
  {
    id: 2,
    name: 'Postman API Tester',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/XAQP1x8QQky_ODEmxjEg-Q/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/XAQP1x8QQky_ODEmxjEg-Q?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on June 2024',
  },
  {
    id: 3,
    name: 'Postman API Adoption',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/JxKDHCGxThihgnTvq-gn0Q/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/JxKDHCGxThihgnTvq-gn0Q?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on June 2024',
  },
  {
    id: 4,
    name: 'Postman APIs 101',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/Fz8Tq7E4QQ-6toPklTAfEQ/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/Fz8Tq7E4QQ-6toPklTAfEQ?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on June 2024',
  },
  {
    id: 5,
    name: '15 days of Postman - for testers',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/6ArWsTLRQSGUUpW-jD35jA/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/6ArWsTLRQSGUUpW-jD35jA?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on May 2024',
  },
  {
    id: 6,
    name: '30 days of Postman - for developers',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/UyCKBoxuTMSbrLSn1Mkqig/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/UyCKBoxuTMSbrLSn1Mkqig?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on May 2024',
  },
  {
    id: 7,
    name: 'Introduction to Postman - HTTP APIs',
    organization: 'Postman',
    imageUrl: 'https://api.badgr.io/public/assertions/6YIl_I1MQlmqBJBTzFiU9w/image',
    linkUrl: 'https://badges.parchment.com/public/assertions/6YIl_I1MQlmqBJBTzFiU9w?utm_source=url_copy&identity__email=melvin.ferdion%40gmail.com',
    description: 'Issued on May 2024',
  },
];


export const Certifications = () => {
  const [selectedCert, setSelectedCert] = useState(null);
  const [selectedBadge, setSelectedBadge] = useState(null);

  const renderCertificationCard = (cert, index) => (
    <motion.div
      key={cert.id}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.6 }}
      className="bg-slate-900/30 border border-white/5 overflow-hidden hover:border-emerald-500/30 transition-all duration-300 group"
      data-testid={`certification-card-${index}`}
    >
      {/* Certificate Image */}
      <div
        className="relative h-48 bg-slate-800/50 cursor-pointer overflow-hidden"
        onClick={() => setSelectedCert(cert)}
        data-testid={`certification-image-${index}`}
      >
        <img
          src={cert.imageUrl}
          alt={cert.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<div class="flex items-center justify-center h-full"><div class="text-slate-500">Certificate Preview</div></div>';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-60"></div>
        <div className="absolute top-4 right-4 bg-emerald-600 p-2 rounded-full">
          <Award className="w-5 h-5 text-white" />
        </div>
      </div>

      {/* Certificate Info */}
      <div className="p-6 space-y-4">
        <div>
          <h3
            className="text-lg font-medium text-white mb-2 line-clamp-2"
            style={{ fontFamily: 'Outfit' }}
            data-testid={`certification-name-${index}`}
          >
            {cert.name}
          </h3>
          <p className="text-sm text-slate-400" style={{ fontFamily: 'IBM Plex Sans' }}>
            {cert.organization}
          </p>
          {cert.description && (
            <p className="text-xs text-slate-500 mt-2" style={{ fontFamily: 'IBM Plex Sans' }}>
              {cert.description}
            </p>
          )}
        </div>

        <div className="flex space-x-3">
          <button
            onClick={() => setSelectedCert(cert)}
            className="flex-1 px-4 py-2 bg-emerald-600/10 border border-emerald-500/20 text-emerald-400 text-sm rounded-sm hover:bg-emerald-600/20 transition-colors duration-200"
            data-testid={`view-cert-button-${index}`}
          >
            View Certificate
          </button>
          <a
            href={cert.pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-slate-800/50 border border-white/10 text-white text-sm rounded-sm hover:bg-slate-800 transition-colors duration-200 flex items-center justify-center"
            data-testid={`download-cert-button-${index}`}
          >
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </motion.div>
  );

  const renderBadgeCard = (badge, index) => (
    <motion.div
      key={badge.id}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.6 }}
      className="bg-slate-900/30 border border-white/5 overflow-hidden hover:border-emerald-500/30 transition-all duration-300 group"
      data-testid={`badge-card-${index}`}
    >
      {/* Badge Image */}
      <div
        className="relative h-48 bg-slate-800/50 cursor-pointer overflow-hidden flex items-center justify-center"
        onClick={() => setSelectedBadge(badge)}
        data-testid={`badge-image-${index}`}
      >
        <img
          src={badge.imageUrl}
          alt={badge.name}
          className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<div class="flex items-center justify-center h-full"><div class="text-slate-500">Badge Preview</div></div>';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-60"></div>
        <div className="absolute top-4 right-4 bg-amber-600 p-2 rounded-full">
          <Medal className="w-5 h-5 text-white" />
        </div>
      </div>

      {/* Badge Info */}
      <div className="p-6 space-y-4">
        <div>
          <h3
            className="text-lg font-medium text-white mb-2 line-clamp-2"
            style={{ fontFamily: 'Outfit' }}
            data-testid={`badge-name-${index}`}
          >
            {badge.name}
          </h3>
          <p className="text-sm text-slate-400" style={{ fontFamily: 'IBM Plex Sans' }}>
            {badge.organization}
          </p>
          {badge.description && (
            <p className="text-xs text-slate-500 mt-2" style={{ fontFamily: 'IBM Plex Sans' }}>
              {badge.description}
            </p>
          )}
        </div>

        <div className="flex space-x-3">
          <button
            onClick={() => setSelectedBadge(badge)}
            className="flex-1 px-4 py-2 bg-amber-600/10 border border-amber-500/20 text-amber-400 text-sm rounded-sm hover:bg-amber-600/20 transition-colors duration-200"
            data-testid={`view-badge-button-${index}`}
          >
            View Badge
          </button>
          {badge.linkUrl && (
            <a
              href={badge.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-slate-800/50 border border-white/10 text-white text-sm rounded-sm hover:bg-slate-800 transition-colors duration-200 flex items-center justify-center"
              data-testid={`verify-badge-link-${index}`}
            >
              <ExternalLink className="w-4 h-4" />
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );

  return (
    <section
      id="certifications"
      className="min-h-screen py-24 sm:py-32"
      data-testid="certifications-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-white mb-4"
            style={{ fontFamily: 'Outfit' }}
            data-testid="certifications-heading"
          >
            My Certifications and Badges
          </h2>
          <p className="text-base leading-relaxed text-slate-300" style={{ fontFamily: 'IBM Plex Sans' }}>
            Every certification and badge represents a milestone in my journey of continuous learning, helping me build stronger technical expertise and stay up to date with industry best practices.
          </p>
        </motion.div>

        {/* Tabs Component */}
        <Tabs defaultValue="certifications" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 bg-slate-900/50 border border-white/10 mb-12">
            <TabsTrigger
              value="certifications"
              className="data-[state=active]:bg-emerald-600 data-[state=active]:text-white text-slate-400"
              data-testid="certifications-tab"
            >
              <Award className="w-4 h-4 mr-2" />
              Certifications
            </TabsTrigger>
            <TabsTrigger
              value="badges"
              className="data-[state=active]:bg-amber-600 data-[state=active]:text-white text-slate-400"
              data-testid="badges-tab"
            >
              <Medal className="w-4 h-4 mr-2" />
              Digital Badges
            </TabsTrigger>
          </TabsList>

          {/* Certifications Tab Content */}
          <TabsContent value="certifications" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {certifications.map((cert, index) => renderCertificationCard(cert, index))}
            </div>
          </TabsContent>

          {/* Badges Tab Content */}
          <TabsContent value="badges" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {badges.map((badge, index) => renderBadgeCard(badge, index))}
            </div>
          </TabsContent>
        </Tabs>
      </div>

      {/* Certificate Preview Dialog */}
      <Dialog open={!!selectedCert} onOpenChange={() => setSelectedCert(null)}>
        <DialogContent className="max-w-4xl bg-slate-900 border border-white/10 p-0" data-testid="cert-preview-dialog">
          {/* Custom Close Button */}
          <button
            onClick={() => setSelectedCert(null)}
            className="absolute right-4 top-4 z-50 rounded-sm p-2 bg-slate-800/80 hover:bg-slate-700 border border-white/10 transition-colors duration-200"
            data-testid="close-cert-dialog"
          >
            <X className="h-5 w-5 text-white" />
            <span className="sr-only">Close</span>
          </button>

          {selectedCert && (
            <div className="space-y-4">
              <div className="p-6 border-b border-white/10">
                <h3 className="text-xl font-medium text-white pr-12" style={{ fontFamily: 'Outfit' }}>
                  {selectedCert.name}
                </h3>
                <p className="text-slate-400 mt-1" style={{ fontFamily: 'IBM Plex Sans' }}>
                  {selectedCert.organization}
                </p>
              </div>
              <div className="p-6 pt-0">
                <img
                  src={selectedCert.imageUrl}
                  alt={selectedCert.name}
                  className="w-full rounded-sm"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const container = e.target.parentElement;
                    container.innerHTML = `
                      <div class="flex flex-col items-center justify-center h-96 space-y-4">
                        <div class="text-slate-500 text-lg">Certificate preview not available</div>
                        <a href="${selectedCert.pdfUrl}" target="_blank" rel="noopener noreferrer" class="px-6 py-3 bg-emerald-600 hover:bg-emerald-500 text-white rounded-sm transition-colors duration-200">
                          View PDF Certificate
                        </a>
                      </div>
                    `;
                  }}
                />
                {selectedCert.description && (
                  <p className="text-slate-400 mt-4 text-center" style={{ fontFamily: 'IBM Plex Sans' }}>
                    {selectedCert.description}
                  </p>
                )}
                <a
                  href={selectedCert.pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 w-full inline-block text-center px-6 py-3 bg-emerald-600 hover:bg-emerald-500 text-white rounded-sm transition-colors duration-200"
                >
                  Show Credential
                </a>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Badge Preview Dialog */}
      <Dialog open={!!selectedBadge} onOpenChange={() => setSelectedBadge(null)}>
        <DialogContent className="max-w-2xl bg-slate-900 border border-white/10 p-0" data-testid="badge-preview-dialog">
          {/* Custom Close Button */}
          <button
            onClick={() => setSelectedBadge(null)}
            className="absolute right-4 top-4 z-50 rounded-sm p-2 bg-slate-800/80 hover:bg-slate-700 border border-white/10 transition-colors duration-200"
            data-testid="close-badge-dialog"
          >
            <X className="h-5 w-5 text-white" />
            <span className="sr-only">Close</span>
          </button>

          {selectedBadge && (
            <div className="space-y-4">
              <div className="p-6 border-b border-white/10">
                <h3 className="text-xl font-medium text-white pr-12" style={{ fontFamily: 'Outfit' }}>
                  {selectedBadge.name}
                </h3>
                <p className="text-slate-400 mt-1" style={{ fontFamily: 'IBM Plex Sans' }}>
                  {selectedBadge.organization}
                </p>
              </div>
              <div className="p-6 pt-0 flex flex-col items-center">
                <img
                  src={selectedBadge.imageUrl}
                  alt={selectedBadge.name}
                  className="w-full max-w-md rounded-sm"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const container = e.target.parentElement;
                    container.innerHTML = `
                      <div class="flex flex-col items-center justify-center h-96 space-y-4">
                        <div class="text-slate-500 text-lg">Badge preview not available</div>
                        ${selectedBadge.linkUrl ? `
                          <a href="${selectedBadge.linkUrl}" target="_blank" rel="noopener noreferrer" class="px-6 py-3 bg-amber-600 hover:bg-amber-500 text-white rounded-sm transition-colors duration-200">
                            Show Credential
                          </a>
                        ` : ''}
                      </div>
                    `;
                  }}
                />
                {selectedBadge.description && (
                  <p className="text-slate-400 mt-4 text-center" style={{ fontFamily: 'IBM Plex Sans' }}>
                    {selectedBadge.description}
                  </p>
                )}
                {selectedBadge.linkUrl && (
                  <a
                    href={selectedBadge.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 w-full inline-block text-center px-6 py-3 bg-amber-600 hover:bg-amber-500 text-white rounded-sm transition-colors duration-200"
                  >
                    Show Credential
                  </a>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};